import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-media',
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.css']
})
export class MediaComponent implements OnInit {

  constructor(private router: Router) { }
  

  ngOnInit(): void {
  }
  backClicked() {
    if (this.router.navigated) {
      this.router.navigate(['/'])
    } else {
      this.router.navigate(['/'])
    }
  }

}
